module.exports = __webpack_public_path__ + "img/course-4.64bb041d.png";